import { SxProps } from "@mui/material";

export const sxTitle: SxProps = {
    fontSize: '20px',
    textAlign: 'center',
    fontFamily: "UnimedSans-Bold",
    color: "#383838",
}

export const sxCard: SxProps = {
    display: 'flex',
    gap: '16px',
    borderRadius: '12px',
    background: '#fff',
    boxShadow: '0px 4px 8px 0px #00000014',
    border: '1px solid #EEEEEE',
    padding: '12px 24px',
    cursor: 'pointer',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'start',
    textTransform: 'none',
    '&:hover': {
        boxShadow: '0px 4px 50px 0px #00000014',
        backgroundColor: '#FFF'
    }
}